import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';

export interface NavItem {
  to: string;
  label: string;
  icon: string;
}

/** Sidebar shell — same skeleton as servicedesk-portal/health-portal's Shell.tsx. */
export function Shell({ title, items }: { title: string; items: NavItem[] }) {
  const { persona, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen">
      <aside className="fixed inset-y-0 left-0 flex w-60 flex-col bg-ink-950">
        <div className="flex items-center gap-2.5 px-5 py-5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-600 text-sm font-black text-white">YSC</div>
          <div>
            <div className="text-sm font-bold leading-tight text-white">One Gov Seychelles</div>
            <div className="text-[11px] text-slate-400">{title}</div>
          </div>
        </div>
        <nav className="flex-1 space-y-0.5 px-3 py-2">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to.split('/').length <= 2}
              className={({ isActive }) =>
                `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition ${
                  isActive ? 'bg-brand-600 text-white' : 'text-slate-300 hover:bg-ink-800 hover:text-white'
                }`
              }
            >
              <span className="w-5 text-center">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-ink-800 px-5 py-4">
          <div className="text-sm font-semibold text-white">{persona?.name}</div>
          <div className="text-[11px] leading-snug text-slate-400">{persona?.title}</div>
          <div className="text-[11px] leading-snug text-slate-500">{persona?.org}</div>
          <div className="mt-1.5 flex flex-wrap gap-1">
            {persona?.roles.map((r) => (
              <span key={r} className="rounded bg-ink-800 px-1.5 py-0.5 text-[9px] font-medium text-slate-400 ring-1 ring-ink-700">
                {r.replaceAll('_', ' ')}
              </span>
            ))}
          </div>
          <button
            className="mt-3 w-full rounded-lg border border-ink-700 px-3 py-1.5 text-xs font-semibold text-slate-300 hover:bg-ink-800"
            onClick={() => {
              logout();
              navigate('/');
            }}
          >
            Switch user
          </button>
        </div>
      </aside>
      <main className="ml-60 flex-1 px-8 py-7">
        <Outlet />
      </main>
    </div>
  );
}
